<template>
  <div>
    <div class="recommendationsViewHeader">Вам будет интересно</div>
    <div class="recommendationsView">
      <ShopCard
          v-for="shopCard in shopCards"
          :key="shopCard.id"
          :item="shopCard"
      >
      </ShopCard>
    </div>
  </div>
</template>

<script>
import ShopCard from "@/components/CatalogView/ShopCard.vue";
import {usePriceItemStore} from "@/store/price-items";
import {computed} from "vue";
import environment from "@/environment";

export default {
  name: "RecommendationsView",
  components: {ShopCard},
  setup() {
    const priceItemStore = usePriceItemStore()

    const shopCards = computed(() => {
      const categories = priceItemStore.items.filter(
          category => category.category_id === environment.appConfig.productCategory
              ||  category.category_id === environment.appConfig.merchCategory
      )
      return categories
          .flatMap(category => category.price_list_items) //беру вложенные price_list_items
          .sort(() => Math.random() - 0.5)
          .slice(0, 5); // Беру верхние 5
    });

    return {shopCards}
  }

}
</script>


<style scoped lang="scss">
.recommendationsView {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  text-align: left;
  width: 100%;
}

.recommendationsViewHeader {
  text-align: left;
  font-family: var(--cd-bold-font);
  font-weight: 600;
  font-size: clamp(18px, 3vw, 26px);
  color: var(--cd-highlight-text);
  padding: 10px;
}
</style>
